import { AdminClient, AdminUser } from '@storefronts/common-types'
import React, { Dispatch, SetStateAction } from 'react'

type AuthContextState = {
    isLoggedIn: boolean | null
    isSuperUser: boolean
    user: AdminUser | null
    client: AdminClient | null
    setUser: Dispatch<SetStateAction<AdminUser | null>>
    setClient: Dispatch<SetStateAction<AdminClient | null>>
    setLoggedIn: Dispatch<SetStateAction<boolean | null>>
    setIsSuperUser: Dispatch<SetStateAction<boolean>>
}

export const initialAuthState: AuthContextState = {
    isLoggedIn: null,
    isSuperUser: false,
    user: null,
    client: null,
    setUser: () => {},
    setClient: () => {},
    setLoggedIn: () => {},
    setIsSuperUser: () => {},
}

export const AuthContext =
    React.createContext<AuthContextState>(initialAuthState)
